(function () {
  function initScrollToTop() {
    var button = document.querySelector('.scroll-to-top');
    if (!button) return;

    var heroSelector = '.shopify-section:first-of-type';
    var hero = document.querySelector(heroSelector);
    var heroBottom = hero ? hero.offsetTop + hero.offsetHeight : 400;

    function updateVisibility() {
      if (window.scrollY > heroBottom) {
        button.classList.add('is-visible');
      } else {
        button.classList.remove('is-visible');
      }
    }

    function scrollToTop(e) {
      e.preventDefault();
      var target = document.querySelector('#MainContent') || document.documentElement;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    window.addEventListener('scroll', updateVisibility, { passive: true });
    button.addEventListener('click', scrollToTop);

    updateVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollToTop);
  } else {
    initScrollToTop();
  }
})();
